"use client";

import Link from "next/link";
import styled from "styled-components";

const FooterContainer = styled.footer`
  background-color: #2c3e50;
  color: #ecf0f1;
  padding: 3rem 2rem 1.5rem;
  margin-top: auto;
  width: 100%;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;

const FooterTop = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;

  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`;

const FooterSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const FooterTitle = styled.h4`
  font-size: 1.125rem;
  font-weight: 600;
  margin: 0;
  color: #c8553d;
`;

const FooterLinks = styled.ul`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`;

const FooterLink = styled(Link)`
  color: #ecf0f1;
  text-decoration: none;
  font-size: 0.9rem;
  transition: color 0.3s ease;

  &:hover {
    color: #c8553d;
  }
`;

const FooterBottom = styled.div`
  border-top: 1px solid rgba(236, 240, 241, 0.2);
  padding-top: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 1rem;

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
  }
`;

const Copyright = styled.p`
  margin: 0;
  font-size: 0.875rem;
  color: #bdc3c7;
`;

const LegalLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  font-size: 0.875rem;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 0.5rem;
  }
`;

const LegalLink = styled(Link)`
  color: #bdc3c7;
  text-decoration: none;
  transition: color 0.3s ease;

  &:hover {
    color: #c8553d;
  }
`;

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <FooterSection>
            <FooterTitle>About Drizl</FooterTitle>
            <FooterLinks>
              <li>
                <FooterLink href="/about">About Us</FooterLink>
              </li>
              <li>
                <FooterLink href="/how-it-works">How It Works</FooterLink>
              </li>
              <li>
                <FooterLink href="/contact">Contact Us</FooterLink>
              </li>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <FooterTitle>For Consumers</FooterTitle>
            <FooterLinks>
              <li>
                <FooterLink href="/feed">Browse Meals</FooterLink>
              </li>
              <li>
                <FooterLink href="/orders">My Orders</FooterLink>
              </li>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <FooterTitle>For Artisans</FooterTitle>
            <FooterLinks>
              <li>
                <FooterLink href="/artisan-dashboard">
                  Artisan Dashboard
                </FooterLink>
              </li>
              <li>
                <FooterLink href="/register">Become an Artisan</FooterLink>
              </li>
              <li>
                <FooterLink href="/artisan-faq">Artisan FAQ</FooterLink>
              </li>
            </FooterLinks>
          </FooterSection>

          <FooterSection>
            <FooterTitle>Support</FooterTitle>
            <FooterLinks>
              <li>
                <FooterLink href="/help">Help Center</FooterLink>
              </li>
              <li>
                <FooterLink href="/safety">Safety Guidelines</FooterLink>
              </li>
              <li>
                <FooterLink href="/faq">FAQ</FooterLink>
              </li>
            </FooterLinks>
          </FooterSection>
        </FooterTop>

        <FooterBottom>
          <Copyright>
            © {currentYear} Drizl, LLP. All rights reserved.
          </Copyright>
          <LegalLinks>
            <LegalLink href="/terms">Terms & Conditions</LegalLink>
            <LegalLink href="/privacy">Privacy Policy</LegalLink>
          </LegalLinks>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer;
